// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoiceno-width[data-v-2835d60b] {\n  min-width: 12em;\n}\n.invoicedate-width[data-v-2835d60b] {\n  min-width: 8em;\n}\n.abn-width[data-v-2835d60b] {\n  min-width: 8em;\n}", ""]);
// Exports
module.exports = exports;
